import { createGlobalStyle } from "styled-components";

/**
 * A página pública não usa o tema escuro do sistema: é tela de conversão, não
 * de operação. O estilo fica local para não vazar para o resto do app.
 */
export const OrcamentoGlobalStyle = createGlobalStyle`
  .orcamento-publico {
    --op-ink: #15151c;
    --op-muted: #5d5d72;
    --op-faint: #8a8aa0;
    --op-line: #e1e1ee;
    --op-line-strong: #c9c9dc;
    --op-surface: #ffffff;
    --op-surface-2: #fafafe;
    --op-bg: #f5f5fa;
    --op-indigo: #262f6e;
    --op-indigo-lift: #3b48a8;
    --op-indigo-wash: #edeef9;
    --op-crimson: #a8123a;
    --op-amber: #e8ae0b;
    --op-amber-ink: #6b4e00;
    --op-amber-wash: #fdf4dc;
    --op-teal: #2aafc0;

    min-height: 100vh;
    background: var(--op-bg);
    color: var(--op-ink);
    font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif;
    text-align: left;
  }

  .orcamento-publico *, .orcamento-publico *::before, .orcamento-publico *::after {
    box-sizing: border-box;
  }

  .orcamento-publico .op-num {
    font-variant-numeric: tabular-nums;
  }

  .orcamento-publico .op-inp {
    width: 100%;
    padding: 10px 12px;
    font-size: 15.5px;
    color: var(--op-ink);
    background: var(--op-surface-2);
    border: 1.5px solid var(--op-line);
    border-radius: 9px;
    transition: border-color .12s;
  }
  .orcamento-publico .op-inp::placeholder { color: var(--op-faint); }
  .orcamento-publico .op-inp:focus {
    outline: none;
    border-color: var(--op-indigo);
    background: var(--op-surface);
  }
  .orcamento-publico .op-inp[aria-invalid="true"] { border-color: var(--op-crimson); }

  .orcamento-publico .op-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    padding: 13px 22px;
    border-radius: 11px;
    border: 1.5px solid transparent;
    font-weight: 700;
    font-size: 15.5px;
    cursor: pointer;
    transition: background .13s, border-color .13s;
  }
  .orcamento-publico .op-btn:disabled { cursor: not-allowed; opacity: .55; }
  .orcamento-publico .op-btn-primary { background: var(--op-indigo); color: #fff; }
  .orcamento-publico .op-btn-primary:hover:not(:disabled) { background: var(--op-indigo-lift); }
  .orcamento-publico .op-btn-ghost {
    background: transparent;
    border-color: var(--op-line-strong);
    color: var(--op-ink);
  }
  .orcamento-publico .op-btn-ghost:hover:not(:disabled) {
    border-color: var(--op-indigo);
    color: var(--op-indigo);
  }

  .orcamento-publico .op-panel {
    background: var(--op-surface);
    border: 1px solid var(--op-line);
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(20,20,40,.06), 0 8px 24px -12px rgba(20,20,40,.18);
  }

  /* Passo ainda indisponível: some do fluxo de foco também, não só da vista. */
  .orcamento-publico .op-step[data-bloqueado="true"] {
    opacity: .42;
    pointer-events: none;
    filter: saturate(.4);
  }

  .orcamento-publico .op-opt {
    display: block;
    width: 100%;
    text-align: left;
    cursor: pointer;
    background: var(--op-surface);
    border: 1.5px solid var(--op-line);
    border-radius: 12px;
    padding: 14px 15px;
    transition: border-color .13s, background .13s;
  }
  .orcamento-publico .op-opt:hover { border-color: var(--op-line-strong); }
  .orcamento-publico .op-opt[aria-pressed="true"] {
    border-color: var(--op-indigo);
    background: var(--op-indigo-wash);
  }

  .orcamento-publico .op-cat { width: 100%; border-collapse: collapse; min-width: 520px; }
  .orcamento-publico .op-cat th {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: .13em;
    text-transform: uppercase;
    color: var(--op-faint);
    text-align: right;
    padding: 11px 14px;
    border-bottom: 1px solid var(--op-line);
    white-space: nowrap;
  }
  .orcamento-publico .op-cat th:first-child { text-align: left; }
  .orcamento-publico .op-cat td {
    padding: 9px 14px;
    border-bottom: 1px solid var(--op-line);
    text-align: right;
    font-size: 14.5px;
  }
  .orcamento-publico .op-cat td:first-child { text-align: left; }
  .orcamento-publico .op-cat tr.op-item { cursor: pointer; }
  .orcamento-publico .op-cat tr.op-item:hover { background: var(--op-surface-2); }
  .orcamento-publico .op-cat tr.op-item[data-marcado="true"] { background: var(--op-indigo-wash); }
  .orcamento-publico .op-cat tr.op-item[data-bloqueado="true"] { cursor: not-allowed; opacity: .55; }
  .orcamento-publico .op-cat tr.op-item[data-bloqueado="true"]:hover { background: transparent; }
  .orcamento-publico .op-cat tfoot td {
    border-top: 1.5px solid var(--op-line-strong);
    border-bottom: none;
    padding-top: 12px;
  }
`;
